import { useState, useEffect } from "react";
import { useRecoilState } from "recoil";
import { FiBriefcase, FiSave } from "react-icons/fi";
import { toast } from "react-toastify";
import myInfoAtom from "../atoms/myInfoAtom";
import patchData from "../custom_functions/patchData";
import { url } from "../utils/config";

function Setting() {
  const [myInfo, setMyInfo] = useRecoilState(myInfoAtom);
  const [companyName, setCompanyName] = useState(myInfo?.company_name || "");
  const [isSaving, setIsSaving] = useState(false);

  // Update companyName when myInfo loads
  useEffect(() => {
    if (myInfo?.company_name) {
      setCompanyName(myInfo.company_name);
    }
  }, [myInfo?.company_name]);

  const handleUpdateOrganization = () => {
    if (!companyName.trim()) {
      toast.error("Company name is required", { autoClose: 3000 });
      return;
    }

    if (!myInfo?.id) {
      toast.error("Unable to update: User ID not found", { autoClose: 3000 });
      return;
    }

    setIsSaving(true);
    patchData(
      `${url}/fleet_customers/${myInfo.id}`,
      { company_name: companyName.trim() },
      (error) => {
        setIsSaving(false);
        toast.error(error?.response?.data?.message || "Failed to update organization", { autoClose: 3000 });
      },
      (response) => {
        setIsSaving(false);
        const updatedCompanyName = response?.data?.company_name || companyName.trim();
        setCompanyName(updatedCompanyName);
        setMyInfo((prev) => ({ ...prev, company_name: updatedCompanyName }));
        toast.success("Organization updated successfully", { autoClose: 3000 });
      }
    );
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-neutral-900">Settings</h1>
      </div>

      {/* Content */}
      <div className="bg-white rounded-2xl shadow-[0_12px_30px_rgba(22,101,52,0.12)] border border-emerald-100 overflow-hidden">
        <div className="flex items-center gap-2 px-6 py-4 border-b border-emerald-100 bg-emerald-50/50">
          <FiBriefcase size={18} className="text-emerald-700" />
          <span className="text-sm font-semibold text-emerald-700">Organization</span>
        </div>

        {/* Tab Content */}
        <div className="p-6">
          <div className="space-y-6">
            <div>
              <h2 className="text-lg font-bold text-emerald-900 mb-1">Organization Details</h2>
              <p className="text-sm text-neutral-500">Manage your organization information</p>
            </div>

            <div className="max-w-md space-y-4">
              <div>
                <label className="mb-2 block text-xs font-semibold uppercase tracking-wide text-emerald-600">
                  Company Name
                </label>
                <input
                  type="text"
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                  placeholder="Enter company name"
                  className="w-full rounded-xl border border-emerald-200 bg-white px-4 py-3 text-sm text-emerald-900 shadow-sm placeholder:text-emerald-300 focus:outline-none focus:ring-2 focus:ring-emerald-400"
                />
              </div>

              <button
                type="button"
                onClick={handleUpdateOrganization}
                disabled={isSaving}
                className={`inline-flex items-center gap-2 rounded-full px-6 py-2.5 text-sm font-semibold text-white transition-colors ${
                  isSaving
                    ? "bg-emerald-300 cursor-not-allowed"
                    : "bg-emerald-600 hover:bg-emerald-700 shadow-[0_8px_20px_rgba(16,185,129,0.25)]"
                }`}
              >
                <FiSave size={16} />
                <span>{isSaving ? "Saving..." : "Save Changes"}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Setting;
